<template lang="pug">
.stock-container
    StockIndexBoard.mb20
    .stock-layout(v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.1)")
        .stock-search-container
            el-input.stock-search(placeholder="请输入股票名称" v-model="keyword" @change="search" class="input-with-select")
                el-button(slot="append" icon="el-icon-search")
        .stock-list(v-if="list && list.length")
            .stock.box(v-for="item in list" :key="item.code")
                router-link(:to="`/stock/${item.code}`")
                    h4 {{item.name}}
                    p {{item.code.replace(/[a-zA-Z]+/, '')}}
                    h4(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") &yen;{{(item.latest_price).toFixed(2)}}
                    p(:class="item.latest_price - item.close_price >= 0 ? 'red' : 'green'") 涨跌幅：  {{(item.latest_price - item.close_price).toFixed(2)}}
                            | ({{((item.latest_price - item.close_price) / item.close_price  * 100).toFixed(2)}}%)
                    p 昨日收盘价： &yen;{{(item.close_price).toFixed(2)}}
                    p {{item.date }} {{item.time }}
        .empty(v-else-if="!loading")
            el-empty(description="暂无数据")
        el-pagination.stock-page(background layout="prev, pager, next" :page-size="size" :total="count" :current-page="page" hide-on-single-page @current-change="pageChange")
</template>

<script>
import storeMixin from '../store/mixin';
import StockIndexBoard from '../components/stock-index-board.vue';
import intervalMixin from '../components/interval-mixin.vue';

export default {
    mixins: [storeMixin, intervalMixin],
    components: { StockIndexBoard },
    name: 'Stock',
    data() {
        return {
            list: null,
            loading: false,
            size: 30,
            count: 0,
            page: 1,
            keyword: '',
        };
    },
    created() {
        console.log('created');
        this.getList();
    },
    methods: {
        mixinIntervalMethods() {
            this.getList();
        },
        async getList() {
            if (this.loading) return;
            this.loading = true;
            try {
                const result = await this.REQUEST({
                    url: `v2/finance/stock/list?mode=follow&limit=${this.size}&page=${this.page}&q=${this.keyword}`,
                });
                this.list = result.data.items;
                this.count = result.data.count;
            } catch (e) {
                console.log(e);
            }
            this.loading = false;
        },
        search() {
            this.page = 1;
            this.getList();
        },
        pageChange(n) {
            this.page = n;
            this.getList();
        },
    },
};
</script>

<style lang="stylus" scoped>
.stock-container
    width 1000px
    margin 0 auto
.stock-layout
    position relative
.stock-list
    display flex
    flex-wrap: wrap;
.stock
    width 20%
    flex-grow 0
    border-radius 10px
    padding 10px
    margin 5px
    user-select none
    cursor pointer
    h4
        font-size 1.6em
    p
        white-space nowrap
        color #666
        &.green
            color green
        &.red
            color red

    &:hover, &active
        box-shadow 0 0 3px 2px #3b56ce
    a
        color #fff
        text-decoration none
.stock-page
    text-align center
    margin 20px 0
.stock-search-container
    padding 20px
    text-align center
    background #1e1f25
    margin 0 0 20px 0
.stock-search
    width 80%
    max-width 600px
    min-width 200px
</style>
